<object
  type="image/svg+xml"
  data="assets/assets-site/images/svg-illustrations/loader.svg"
  class="w-[70px]"
></object>
